import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faHeart, faCommentAlt, faClock } from '@fortawesome/free-regular-svg-icons';

import { SanitizedHTML } from '../utils/Helper';

const PostActivity = ({ views, liked, comment, reading_time }) => {
    const activityItems = [
        { icon: faChartLine, label: views },
        { icon: faHeart, label: liked },
        { icon: faCommentAlt, label: comment },
        { icon: faClock, label: <SanitizedHTML className="activity-label" html={reading_time} tag="span" /> },
    ];

    return (
        <div className="common-wrapper mb-4 position-relative">
            <h3 className="mb-4 fw-500 text-uppercase text-4">Post Activity</h3>
            <div className="activity-container d-flex gap20">
                {activityItems.map((item, index) => (
                    <div key={index} className="activity-item d-flex gap5 align-items-center">
                        <span className="activity-icon text-2 text-muted">
                            <FontAwesomeIcon icon={item.icon} />
                        </span>
                        {typeof item.label === 'string' || typeof item.label === 'number' ? (
                            <span className="activity-label text-2">{item.label}</span>
                        ) : (
                            item.label
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

PostActivity.propTypes = {
    views: PropTypes.string,
    liked: PropTypes.number,
    comment: PropTypes.number,
    reading_time: PropTypes.string,
};

PostActivity.defaultProps = {
    views: '',
    liked: 0,
    comment: 0,
    reading_time: '',
};

export default PostActivity;